import { CONTENTFUL_CACHE_STORAGE_KEY } from '../../contentful-content-type-entries-machine.constants';
import { hasKey } from '../cache';

/**
 * Checks to see if the relevant cache entry for the supplied query exists.
 */
export async function checkIfCacheEntryExists(queryHash = '') {
  return hasKey(`${CONTENTFUL_CACHE_STORAGE_KEY}.${queryHash}`);
}
